import { QueryClient } from '@tanstack/react-query';
import { STALE } from './queryPolicy';

// gcTime MUST be >= the persister's maxAge (24h — see queryPersister.ts) or a
// query restored from IndexedDB gets garbage-collected from memory almost
// immediately after restore, silently defeating the persisted cache (perf
// plan §4.6 gotcha).
export const PERSIST_MAX_AGE_MS = 24 * 60 * 60 * 1000; // 24 hours

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: STALE.standard, // 5 minutes - data is considered fresh for this time
      gcTime: PERSIST_MAX_AGE_MS, // 24 hours - must stay >= persister maxAge
      refetchOnWindowFocus: false, // Don't refetch when user returns to tab
      refetchOnReconnect: true, // Do refetch when internet reconnects
      retry: 1, // Retry failed requests once
      retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000), // Exponential backoff
    },
    mutations: {
      retry: 0, // Don't retry mutations by default
    },
  },
});
